import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import type { SvgIconComponent } from '@mui/icons-material';
import type { BadgeVariant } from '../../../components/ui/badgeVariants';
import type { ContractStatus } from './contractStatus';

/** Presentation for one contract status: themed badge variant + icon + i18n label. */
export interface ContractStatusVariant {
  /** Semantic badge variant → themed colours via `BADGE_VARIANTS`. No raw colours. */
  variant: BadgeVariant;
  icon: SvgIconComponent;
  /** i18n key under `employeeTables.contractStatus`. */
  labelKey: string;
}

const I18N_PREFIX = 'employeeTables.contractStatus';

/**
 * State → presentation. Activé (success/check) and Non activé (warning/alert) are
 * distinguished by **icon + label**, not colour alone, for accessibility.
 */
export const CONTRACT_STATUS_VARIANT: Record<ContractStatus, ContractStatusVariant> = {
  current_activated: {
    variant: 'success',
    icon: CheckCircleOutlineIcon,
    labelKey: `${I18N_PREFIX}.currentActivated`,
  },
  current_not_activated: {
    variant: 'warning',
    icon: ErrorOutlineIcon,
    labelKey: `${I18N_PREFIX}.currentNotActivated`,
  },
  current: {
    variant: 'success',
    icon: CheckCircleOutlineIcon,
    labelKey: `${I18N_PREFIX}.current`,
  },
  none: {
    variant: 'neutral',
    icon: RemoveCircleOutlineIcon,
    labelKey: `${I18N_PREFIX}.none`,
  },
};
